// Containers
import GeneralSettingsForm from "../../../../../containers/forms/generalBranchSettingsForms/GeneralSettings/GeneralSettings.form";

const GeneralSettings = ({ branchId }) => {
  return <GeneralSettingsForm branchId={branchId} />;
};

export default GeneralSettings;
